import React, {useState} from 'react';
import PropTypes from 'prop-types';
import i18n from '../../utils/i18n';
import Button from '@adsk/bim360-matrix-react-button';
import {changeLocationAction, trackEvent, updateIssueAction} from '../../app/actions';
import {issueAttributesType} from '../../constants/proptype-validation';
import {ISSUE_ATTRIBUTE_NAMES} from '../../constants/issue-attribute-names';
import {connect} from '../../app/connect';
import useCurrentIssuePreviewPopup from './useCurrentIssuePreviewPopup';
import {unlinkDocumentFromIssue} from '../../utils/analytics-helpers';
import {getCurrentViewType} from '../../app/selectors';
import {viewTypes} from '../../constants/view-types';
import {TYPE_QUALITY_ISSUES} from '../../constants/issue-types';

const IssuePreviewUnlinkConfirmationPopUp = ({issue, dispatch, viewType}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const {setCurrentIssuePreviewPopup} = useCurrentIssuePreviewPopup();

  return (
    <div className="IssuePreviewUnlinkConfirmationPopUp">
      <div className="IssuePreviewUnlinkConfirmationPopUp__content">
        <div className="IssuePreviewUnlinkConfirmationPopUp__content-title">
          {i18n.t('issueAttributes.document.deleteIssuePushpin')}
        </div>
        <div className="IssuePreviewUnlinkConfirmationPopUp__content-description">
          {i18n.t('issueAttributes.document.deleteIssuePushpinDescription')}
        </div>
      </div>
      <div className="IssuePreviewUnlinkConfirmationPopUp__footer">
        <Button
          styleType={Button.StyleType.LINK_SECONDARY}
          onClick={() => {
            setCurrentIssuePreviewPopup(null);
          }}
        >
          {i18n.t('navigation.cancel')}
        </Button>
        <Button
          styleType={Button.StyleType.PRIMARY}
          disabled={isSubmitting}
          onClick={() => {
            setIsSubmitting(true);
            dispatch(
              updateIssueAction(
                issue,
                {
                  [ISSUE_ATTRIBUTE_NAMES.LINKED_DOCUMENTS]: [],
                  [ISSUE_ATTRIBUTE_NAMES.SNAPSHOT_URN]: null
                },
                {
                  onSuccess: () => {
                    setIsSubmitting(false);
                    setCurrentIssuePreviewPopup(null);
                    dispatch(trackEvent(unlinkDocumentFromIssue(viewType)));
                    if (viewType === viewTypes.DOCUMENT) {
                      dispatch(changeLocationAction(`/${TYPE_QUALITY_ISSUES}`));
                    }
                  },
                  onError: () => {
                    setIsSubmitting(false);
                    setCurrentIssuePreviewPopup(null);
                  },
                  forceIssuesV2Api: true
                }
              )
            );
          }}
        >
          {isSubmitting ? i18n.t('navigation.deleting') : i18n.t('navigation.delete')}
        </Button>
      </div>
    </div>
  );
};

IssuePreviewUnlinkConfirmationPopUp.displayName = 'IssuePreviewUnlinkConfirmationPopUp';

IssuePreviewUnlinkConfirmationPopUp.propTypes = {
  issue: issueAttributesType,
  dispatch: PropTypes.func.isRequired,
  viewType: PropTypes.string.isRequired
};

export default connect(state => ({
  viewType: getCurrentViewType(state)
}))(IssuePreviewUnlinkConfirmationPopUp);
